/* eslint-disable no-param-reassign */
import ReactDOM from 'react-dom';
import { IConfig, XS2AConfig } from './sharedInterfaces/SharedInterfaces';

import {
  setupSentryProduction,
  setupUrlParamsInTest,
  validateConfigAndRenderContent,
} from './services/RenderAppService';
import { getLocale } from './utils';

const { version } = require('../package.json');

declare global {
  interface Window {
    qred: any;
    qredWidgetConfig: IConfig[];
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: any;
    dataLayer: any;
    qredUseGtm: boolean;
    testUrl: string | undefined;
    onXS2AReady: (XS2A: any) => void;
    XS2A: {
      startFlow: (token: string, config: XS2AConfig) => {};
      configure: (config: XS2AConfig) => {};
    };
  }
}

setupSentryProduction();

// Create qred namespace
window.qred = () => {};
// Create qred.signup namespace
window.qred.SignupWidget = () => {};

window.qred.SignupWidget.prototype.init = (config: any) => {
  setupUrlParamsInTest(config.settings, version);
  if (config && config.settings && config.settings.id && document) {
    if (window.dataLayer && window.qredUseGtm) {
      try {
        window.dataLayer.push({
          event: 'widget-loaded',
          locale: getLocale(config.settings),
          market: config.settings.market,
          language: config.settings.language,
        });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
      }
    }
    const elementToRenderInto = document.getElementById(config.settings.id);
    ReactDOM.render(validateConfigAndRenderContent(config), elementToRenderInto);
  }

  // Public API should go into this object
  return {
    widgetVersion: version,
  };
};
